import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'helmreleases',
});

export const viewHelmReleaseRouteRef = createSubRouteRef({
  id: 'helmrelease',
  parent: rootRouteRef,
  path: '/yaml/:namespace/:name/:environment/:version',
});
